module.exports = __webpack_public_path__ + "static/media/ReassignIcon.f6f1dac1.svg";